import React from 'react';
import I18n from 'i18n-js';
import { LockKeyIcon } from '@phosphor-icons/react';
import { RCThemedBox, RCFlex, RCIcon, RCText } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';

const HELP_CENTER_ARTICLE_ID = '21894613284627';

const ShopLockedModeBanner = () => {
  return (
    <RCThemedBox themeType="utility" variant="urgent-ultralight">
      <div className="site-wrapper ptb-4">
        <RCFlex gap="4" align={{ desktop: 'center', mobile: 'start' }}>
          <RCIcon size={8} icon={<LockKeyIcon />} color="accent-themed" />
          <RCFlex direction="col" gap="half">
            <RCText.Utility weight="bold" size="450">
              {I18n.t('discovery.sellerDashboard.lockedModeBanner.title')}
            </RCText.Utility>
            <p className="mb-0">
              <Translate text="discovery.sellerDashboard.lockedModeBanner.description" />
              {' '}
              <CoreLink
                target="_blank"
                to={Paths.helpCenterArticlesUrl.expand({ articleId: HELP_CENTER_ARTICLE_ID })}
                className="text-link weight-bold"
              >
                <Translate text="discovery.sellerDashboard.lockedModeBanner.helpCenterLinkText" />
              </CoreLink>
            </p>
          </RCFlex>
        </RCFlex>
      </div>
    </RCThemedBox>
  );
};

export default ShopLockedModeBanner;
